import { render } from "./AXBBinding.vue?vue&type=template&id=480f276e&scoped=true"
import script from "./AXBBinding.vue?vue&type=script&lang=js"
export * from "./AXBBinding.vue?vue&type=script&lang=js"

import "./AXBBinding.vue?vue&type=style&index=0&id=480f276e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-480f276e"

export default script